<evi-vertical-menu>
  <evi-vertical-menu-item
    (tgclick)="onLogout()"
    label="Logout"
  ></evi-vertical-menu-item>
</evi-vertical-menu>
